import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { encrypt, decrypt } from '../functions/mobile';
import LoadingScreen from '../components/Complements/LoadingScreen';
import Dashboard from '../components/Menu/Dashboard';
import DialogOTP from '../components/Complements/DialogOTP';
import ChangeQuotasForm from '../components/ChangeQuotas/ChangeQuotasForm';
import { Grid, makeStyles } from '@material-ui/core';
//import { osName, osVersion } from "react-device-detect";
import { filterArrayEqual } from '../functions/arrays';
import { createCode } from './../actions/codes'
import { updateQuotas } from './../actions/quotas';
import { feathersCreateData } from '../services';
//import { Grid } from '@material-ui/core';
//import Title from './../components/Complements/Title';
import Footer from '../components/Complements/Footer';
import Title from '../components/Complements/Title';
import { IconButton } from '@mui/material';
import { history } from '../helpers/history';
import { ArrowBackIos } from '@mui/icons-material';

class ChangeQuotasContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            datauserquotas: {},
            amountdaily: 0,
            amountmonthly: 0,
            newamountdaily: 0,
            newamountmonthly: 0,
            openDialogOTP: false,
            otp: '',
            initialTime: Date.now(),
            seq: '',
            contAttempts: 0,
            loading: false
        }
    }

    handleChangeInputOtp = (valueinput) => {
        const tokenLengthObj = filterArrayEqual(this.props.parameters, 'code', 'NUMBER_OF_CHARACTERS_TOKEN')
        // console.log(tokenLengthObj)
        const tokenLength = (tokenLengthObj.length > 0) ? parseInt(tokenLengthObj[0].value) : 6
        if (valueinput.target.value.toString().length === tokenLength) {
            // console.log("VALUE OTP: ", valueinput)
            this.receiveOTP({ data: valueinput.target.value.toString() });
        }

    }

    receiveOTP = async (otp) => {
        //this.setState({ otp: otp.data})
        // console.log('el codigo otp ', otp.data)
        try {

            this.setState({
                loading: true
            })
            this.handleCloseDialogOTP()

            const { ip, device, mac } = this.props.devices

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type: 21,
                inputOtp: otp.data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type, viewDialogOtp } = responseValidateCode;

            if (error === false) {

                const { newamountdaily, newamountmonthly } = this.state;

                const sendDataUpdateQuotas = {
                    dataQuotas: encrypt(JSON.stringify({
                        daily: newamountdaily,
                        monthly: newamountmonthly,
                        idQuotas: this.props.quotas[0].id
                    })),
                    device: encrypt(JSON.stringify({
                        ip,
                        mac,
                        device
                    })),
                    otp: encrypt(otp.data)
                }

                const responseUpdateQuotas = await feathersCreateData("quota-validation", sendDataUpdateQuotas)()

                //console.log(responseUpdateQuotas)

                const { message: messageUpdateQuotas, type: typeUpdateQuotas } = responseUpdateQuotas

                this.setState({
                    loading: false
                })

                this.props.handleOpenSnack(messageUpdateQuotas, typeUpdateQuotas)
                // console.log(id)

            } else {
                this.props.handleOpenSnack(message, type)
                if (viewDialogOtp === false) {
                    this.handleCloseDialogOTP()
                }else{
                    this.setState({
                        openDialogOTP: true,
                    })
                }
                this.setState({
                    loading: false
                })
                this.props.handleOpenSnack(message, type);
            }

        } catch (error) {
            this.setState({
                loading: false
            })
            this.props.handleOpenSnack('Ha ocurrido un error al validar el código. Por favor intente nuevamente.', 'error')
        }

    }
    // handle kyuin123
    handleSubmit = async (values) => {
        //console.log(values)
        try {
            const { parameters, devices } = this.props
            
            let amountdailymax = (parameters.length > 0) ? filterArrayEqual(parameters, 'code', 'DAILY_AMOUNT')[0].value : 10000;
            let amountmonthlymax = (parameters.length > 0) ? filterArrayEqual(parameters, 'code', 'MONTHLY_AMOUNT')[0].value : 40000;
            this.setState({ loading: true, amountdaily: values.amountdaily, amountmonthly: values.amountmonthly })

            if ((parseInt(values.amountdaily) <= amountdailymax) && (parseInt(values.amountmonthly) <= amountmonthlymax)) {
                if (parseInt(values.amountdaily) > parseInt(values.amountmonthly)) {
                    this.setState({ loading: false })
                    this.props.handleOpenSnack('El monto diario no puede ser mayor que el monto mensual.', 'error')
                } else {
                    const { ip, mac, device } = devices
                    const sendData = encrypt(JSON.stringify({ emited: 'NAVCREATECODE', type: 21, deviceData: device, ip, mac, action: 'changeQuotas' }))
                    const responseGenerateCode = await feathersCreateData("codes-recovery", { sendData })()
                    const { responseData } = responseGenerateCode
                    const jsonDecrypt = JSON.parse(decrypt(responseData))

                    const { type, alert } = jsonDecrypt;

                    if (type === 'success') {
                        this.setState(
                            {
                                openDialogOTP: true,
                                newamountdaily: values.amountdaily,
                                newamountmonthly: values.amountmonthly,
                                loading: false
                            })
                    } else {
                        this.setState({ loading: false })
                        this.props.handleOpenSnack(alert, type)
                    }

                }
            } else {
                this.setState({ loading: false })
                this.props.handleOpenSnack('Se ha excedido el limite de las cupos. El limite permitido diario es $ ' + amountdailymax + ' y mensual $ ' + amountmonthlymax + '.', 'info');
            }
        } catch (error) {
            this.setState({ loading: false })
            //console.log('error submit', error)
            this.props.handleOpenSnack('No se ha podido realizar la acción. Por favor intente nuevamente.', 'error')
        }

    }

    handleCloseDialogOTP = () => {
        this.setState({ openDialogOTP: false })
    };

    componentDidMount = () => {
        this.setState({
            amountdaily: (this.props.quotas.length > 0) ? this.props.quotas[0].daily : 0,
            amountmonthly: (this.props.quotas.length > 0) ? this.props.quotas[0].monthly : 0
        })
        //console.log(this.props.quotas[0].daily);
    }

    refreshToken = async () => {

        try {

            this.setState({
                loading: true
            })
            const { devices } = this.props
            const { ip, mac, device } = devices
            const sendData = encrypt(JSON.stringify({ emited: 'NAVCREATECODE', type: 21, deviceData: device, ip, mac, action: 'changeQuotas' }))
            const responseGenerateCode = await feathersCreateData("codes-recovery", { sendData })()
            const { responseData } = responseGenerateCode
            const jsonDecrypt = JSON.parse(decrypt(responseData))

            const { type, alert } = jsonDecrypt;

            if (type === 'success') {
                this.setState(
                    {
                        openDialogOTP: true,
                        loading: false
                    })
            } else {
                this.setState({
                    loading: false
                })
                this.props.handleOpenSnack(alert, type)
            }

        } catch (error) {
            this.setState({
                loading: false
            })
            this.props.handleOpenSnack("Ha ocurrido un error al generar el código.", "error")
        }
    }

    renderBody = () => {

        const useStyles = makeStyles(theme => ({
            textField: {
                width: 200,
            },
            margin: {
                margin: theme.spacing(1),
            },
        }));
        const timeLifeTokenObj = filterArrayEqual(this.props.parameters, 'code', 'TIME_LIFE_TOKEN')
        const timeLifeToken = (timeLifeTokenObj.length > 0) ? Number(timeLifeTokenObj[0].value) : 180000

        const amountdailymax = (this.props.parameters.length > 0) ? filterArrayEqual(this.props.parameters, 'code', 'DAILY_AMOUNT')[0].value : 10000;

        const lengthToken = (this.props.parameters.length > 0) ? filterArrayEqual(this.props.parameters, 'code', 'NUMBER_OF_CHARACTERS_TOKEN')[0].value : 6;

        return <div>
            <Grid xs={12} >
                <Title><IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>Cambio de cupo</Title>
            </Grid>
            <ChangeQuotasForm
                {...this.state}
                classes={useStyles}
                amountDaily = {amountdailymax}
                onSubmit={this.handleSubmit}
            />
            <DialogOTP
                {...this.state}
                showQR={false}
                onCloseDialogOTP={this.handleCloseDialogOTP}
                onKeyPress={this.handleChangeInputOtp}
                OTPSubmit={this.receiveOTP}
                initialTime={Date.now()}
                timeLifeToken={timeLifeToken}
                refreshToken={this.refreshToken}
                length={lengthToken}
            />
        </div>
    }

    render() {
        const { loading } = this.state

        return (
            <div>
                <LoadingScreen open={loading} />
                <Dashboard
                    title=""
                    body={this.renderBody()}
                    multiple={false}
                />
                <Footer />
            </div>
        );
    }
}

export default withRouter(connect(null, { createCode, updateQuotas })(ChangeQuotasContainer))
